export default __webpack_public_path__ + "static/media/1576.586e3162.png";